import { useDispatch } from "react-redux";
import { Action } from "redux";
import { UseMutationResponse } from "urql";
import { useWrapUrqlFunc } from "./graphql";

export function useWrapUrql<Data, Variables>(
    mutation: UseMutationResponse<Data, Variables>,
    options?: { readonly onSuccessMessage: string | boolean, dispatchOnSuccess?: Action[] }) {
    const dispatch = useDispatch();
    return useWrapUrqlFunc(mutation[1], {
        dispatch,
        dispatchOnSuccess: options?.dispatchOnSuccess,
        onSuccessMessage: options?.onSuccessMessage,
    });
}
